import { render, staticRenderFns } from "./DataEquipQuotations.vue?vue&type=template&id=2c68c85c&scoped=true&lang=pug"
import script from "./DataEquipQuotations.vue?vue&type=script&lang=js"
export * from "./DataEquipQuotations.vue?vue&type=script&lang=js"
import style0 from "./DataEquipQuotations.vue?vue&type=style&index=0&id=2c68c85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c68c85c",
  null
  
)

export default component.exports